import { BaseError, createError, getExtendedErrors } from '@common/neo.tax';
import * as Sentry from '@sentry/react';
import { z } from 'zod';

export const getExtendedErrorsOrDefault = <ErrorType extends BaseError>(
  error: unknown,
  schema: z.ZodType<ErrorType>,
  defaultErrorMessage?: string,
): ErrorType[] => {
  try {
    return getExtendedErrors(error, schema);
  } catch {
    Sentry.addBreadcrumb({ level: 'error', data: { error } });
    Sentry.captureException(createError('ParsingExtendedErrorsFailure', 'Failed to parse extended error object.'));
    throw new Error(defaultErrorMessage || 'An unexpected error occurred. Please try again.');
  }
};
